import { CountdownTimer, MUIIcon, Spinner, useCalcRemainingTime } from "../../../../widgets";
import { IServiceReqApprovalModel, ServiceRequestStatus } from "../models";
import { ServiceReqHelper } from "../helpers";
import { addMinutes } from "../../timeline/helper";
import { useInterval } from "react-use";
import { useServiceRequestContext } from "../service-request";
import { useState } from "react";

export const ServiceRequestApproval = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [disableButtons, setDisableButtons] = useState<boolean>(false);
    const [showRejectButton, setShowRejectButton] = useState<boolean>(true); 
    const [showApproveButton, setShowApproveButton] = useState<boolean>(true); 
    const { result, refetch, updateApprovalStatus } = useServiceRequestContext();
    const { serviceRequest, service } = result || {};
    const endTime = addMinutes(serviceRequest?.endTime, service?.otpTimer);
    const { isFuture } = useCalcRemainingTime({ endTime });

    useInterval(() => {
        if (serviceRequest?.statusCode !== ServiceRequestStatus.Submitted && serviceRequest?.statusCode !== ServiceRequestStatus.AutoApproved && serviceRequest?.statusCode !== ServiceRequestStatus.Approved)
            return;

        refetch()
    }, 5000)

    useInterval(() => {
        if (isFuture !== true) {
            refetch()
        }
    }, (!endTime || !isFuture) ? 5000 : null)

    const handleApprove = (isApproved: boolean) => {
        if (!serviceRequest) return;

        const request: IServiceReqApprovalModel = {
            requestId: serviceRequest.id,
            approved: isApproved
        }

        setLoading(true); 
        setDisableButtons(true);
        isApproved ? setShowRejectButton(false) : setShowApproveButton(false);
        updateApprovalStatus(request)
            .finally(() => {
                setLoading(false); 
            })
    }

    if (!serviceRequest) return <></>;

    if (serviceRequest.statusCode !== ServiceRequestStatus.Submitted) {
        return <div className="text-center fs-7 fw-semibold my-3">
            Request #<span className="fw-bold">{serviceRequest.requestNumber}</span> is {ServiceReqHelper.status(serviceRequest?.statusCode)}, no further action required.
        </div>
    }

    if (!endTime || !service?.otpTimer || service?.otpTimer <= 0 || isFuture !== true ||
        !ServiceReqHelper.isCancellable(serviceRequest?.statusCode))
        return <></>

    return (
        <div className="d-flex gap-5 my-3">
            <CountdownTimer endTime={endTime} label='Waiting for Approval' />
            <div className="flex-fill" />
            <div className="d-flex gap-3 align-self-start">
                {showApproveButton && ( 
                    <button
                        type="button" className="btn btn-sm btn-primary py-2" onClick={() => handleApprove(true)} disabled={loading || disableButtons}>
                        {loading ? <Spinner show={true} /> : <MUIIcon iconName="ThumbUpOutlined" className="me-1" />}
                        <span className='indicator-label'>Approve</span>
                    </button>
                )}
                {showRejectButton && ( 
                    <button
                        type="button" className="btn btn-sm btn-danger py-2" onClick={() => handleApprove(false)} disabled={loading || disableButtons}>
                        {loading ? <Spinner show={true} /> : <MUIIcon iconName="ThumbDownOutlined" className="me-1" />}
                        <span className='indicator-label'>Reject</span>
                    </button>
                )}
            </div>
        </div>
    )
}
